import { trustStats } from '@/mocks/content';

export default function SocialProof() {
  return (
    <section className="relative py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden bg-foreground-900">
          {/* Left - Image */}
          <div className="relative h-72 md:h-80 lg:h-auto overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Curated%20fashion%20items%20thoughtfully%20arranged%20on%20warm%20sand%20colored%20textured%20surface%2C%20soft%20natural%20morning%20light%20streaming%20from%20side%20window%2C%20editorial%20still%20life%20photography%20with%20gentle%20shadows%20and%20organic%20composition%2C%20linen%20fabric%20draped%20alongside%20leather%20accessories%20and%20ceramic%20vessel%2C%20refined%20minimalist%20boutique%20aesthetic%2C%20serene%20and%20inviting%20atmosphere%20with%20harmonious%20neutral%20tones&width=900&height=700&seq=social-proof-v2&orientation=portrait"
              alt="Kakobuy Spreadsheet trusted by thousands"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>

          {/* Right - Content */}
          <div className="flex flex-col justify-center px-8 md:px-12 py-10 md:py-14 relative">
            <div className="text-background-100/20 text-8xl md:text-9xl font-heading absolute top-4 right-6 select-none leading-none">&ldquo;</div>
            <p className="relative text-lg md:text-xl lg:text-2xl text-background-50 leading-relaxed font-heading italic">
              &ldquo;The Kakobuy Spreadsheet has completely changed how I discover products. It saves me hours every week and the community-verified links give me confidence in every purchase.&rdquo;
            </p>
            <div className="mt-6 md:mt-8">
              <p className="text-background-50 font-semibold text-sm md:text-base">Alex M.</p>
              <p className="text-background-200 text-xs md:text-sm mt-0.5">Verified Kakobuy Spreadsheet User, 2+ Years</p>
            </div>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 md:mt-8 inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer w-fit"
            >
              <i className="ri-file-list-3-line"></i>
              Try Kakobuy Spreadsheet
            </a>
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-3 gap-6 md:gap-8 mt-10 md:mt-14">
          {trustStats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3">
                <i className={`${stat.icon} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">{stat.value}</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}